module.exports = __webpack_public_path__ + "img/icon_e21.7684d3cf.png";